import { ConnectedBankAccount } from './ConnectedBankAccount';
import { MissingBankAccount } from 'assets/js/pages/payouts/MissingBankAccount';
import { useFetchPayoutAccount } from 'assets/js/pages/payouts/useFetchPayoutAccount';

const BankAccount = () => {
    const { data: payoutAccount } = useFetchPayoutAccount();

    if (!payoutAccount.data?.merchant_onboarding_complete) {
        return <MissingBankAccount />;
    }

    if (payoutAccount.data.merchant_account_type === 'express') {
        return <ConnectedBankAccount />;
    }
};

export { BankAccount };
